import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import StoreContext from "../../shared/сontext/StoreContext";
import LoginForm from "../../Auth/Forms/LoginForm";
import ResetPasswordForm from "../../Auth/Forms/ResetPassForm";
import PopupPortal from "../../shared/common/PopupWindow";

const PlayForFreeGame = ({ exclCode }) => {
  const { banners } = useStaticQuery(graphql`
    {
      banners: wpPage(slug: {eq: "home"}) {
        gatsby_home {
          playForFree {
            altText
            title
            localFile {
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED, width: 300, quality: 90)
              }
            }
            gatsby_image {
              slideUrl
              slideTitle
              slideDescription
            }
          }
        }
      }
    }
  `);

  const { username } = useContext(StoreContext);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isLoginMode, setIsLoginMode] = useState(true);
  const gameClick = (e, slideUrl) => {
    if (!username) {
      e.preventDefault();
      setIsPopupOpen(true);
    }

    if (!slideUrl) {
      return false;
    }
  };

  const closePopup = () => {
    setIsLoginMode(true);
    setIsPopupOpen(false);
  }

  const toggleReset = () => {
    setIsLoginMode(!isLoginMode);
  }

  useEffect(() => {
    if (username) {
      closePopup();
    }
  }, [username]);

  return (
    <>
      <div className="game-banners">
        {banners.gatsby_home.playForFree.map((item) => {
          const gameImageData = getImage(item.localFile);
          if (item.title !== exclCode && item.gatsby_image.slideUrl) {
            return (
              <div className="game-banner" key={item.title}>
                {item.gatsby_image.slideUrl ?
                  <a href={item.gatsby_image.slideUrl} onClick={(e) =>
                    gameClick(e, item.gatsby_image.slideUrl)}>
                    {item.gatsby_image.slideDescription &&
                      <span className="ribbon">{item.gatsby_image.slideDescription}</span>
                    }
                    {item.gatsby_image.slideTitle &&
                      <span className="game-title">{item.gatsby_image.slideTitle}</span>
                    }
                    <span className="button transparent-button show-more">เล่นเลย</span>
                    <GatsbyImage alt={item.title} image={gameImageData}/>
                  </a> :
                  <div className="a">
                    {item.gatsby_image.slideTitle &&
                      <span className="game-title">{item.gatsby_image.slideTitle}</span>
                    }
                    {item.gatsby_image.slideDescription &&
                      <span className="coming-soon">{item.gatsby_image.slideDescription}</span>
                    }
                    <GatsbyImage alt={item.title} image={gameImageData}/>
                  </div>
                }
              </div>
            )
          }
        })}
      </div>
      <PopupPortal open={isPopupOpen} onClose={() => closePopup()}>
        {isLoginMode ?
          <LoginForm toggleReset={toggleReset}/>
          : <ResetPasswordForm/>
        }
      </PopupPortal>
    </>
  );

};

export default PlayForFreeGame;

PlayForFreeGame.propTypes = {
  exclCode: PropTypes.string,
};
